module.exports = __webpack_public_path__ + "images/clickNReveal_default.png";